/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from 'prop-types';

import React from 'react';
import isEqual from 'react-fast-compare';
import Modal from 'ui-library/modals/Modal';
import HRTemplateStore from 'molbio/crispr/hr-template/HRTemplateStore';
import HRTemplateActions from 'molbio/crispr/hr-template/HRTemplateActions';
import SettingsForm from './SettingsForm';

export default class SettingsModal extends React.Component {
  static propTypes = {
    sequenceId: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const {pam, genome} = HRTemplateStore.getDesignState(props.sequenceId);
    const settings = {
      pam,
      genome: genome.ensemblName,
    };

    this.oldSettings = settings;
    this.state = {settings};
  }

  save = () => {
    const newSettings = this.state.settings;
    const changedSettings = {};
    for (const key in newSettings) {
      const newValue = newSettings[key];
      if (!isEqual(this.oldSettings[key], newValue)) {
        changedSettings[key] = newValue;
      }
    }
    HRTemplateActions.serverUpdate(this.props.sequenceId, changedSettings);
    this.props.onRequestClose();
  };

  handleChangeSettings = (value) => {
    this.setState({settings: value});
  };

  render() {
    return (
      <Modal
        title="HR template design settings"
        onRequestSubmit={this.save}
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: 'Save',
            submit: true,
          },
        ]}
      >
        <SettingsForm settings={this.state.settings} onChange={this.handleChangeSettings} />
      </Modal>
    );
  }
}
